import React, { createRef } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { CSVLink } from 'react-csv';
import OrderAdditionalInfo from 'pages/ipu/OrderAdditionalInfo';
import Button from 'components/Button';
import TextField from 'components/TextField';
import DeleteIcon from '@material-ui/icons/Delete';
import FormFields from 'pages/ipu/OrderFormFields';
import { updateStaplesOrder } from 'actions/orders';
import { openCloudinaryWidget } from 'pages/ipu/Header';
import { updateReceivedQty } from 'actions/orders';
import {
  StyledForm,
  Order,
  FormWrapper,
  SimpleCard,
  FormHeader,
  FromHeaderTitle,
  ButtonWrapper,
  PrintAreasWrapper,
  PrintAreasHeader,
  StaplesShippedDate,
} from 'styles/pages/staples-bulk-orders';

const csvFileRef = createRef();

const Form = ({ state, setState }) => {
  const dispatch = useDispatch();
  const lineItems = state?.orderPdfData?.lineItems;
  const additionalInfoWithLineItems = state?.additionalInfoWithLineItems;
  const isLineItemEmptyInAdditionalInfo = !!additionalInfoWithLineItems?.find(
    (a) => !a?.lineItems?.length
  );

  const handleAdditionalInfoFieldChange = (key, value, i, j) =>
    setState({
      ...state,
      additionalInfoWithLineItems: additionalInfoWithLineItems?.map((a, k) => {
        if (i != k) {
          return a;
        }

        return {
          ...a,
          lineItems: a?.lineItems?.map((m, l) => {
            if (l != j) {
              return m;
            }

            return {
              ...m,
              [key]: value,
            };
          }),
        };
      }),
    });

  const handleFieldChange = (key, value, i) => {
    setState({
      ...state,
      orderPdfData: {
        ...state.orderPdfData,
        lineItems: lineItems?.map((m, j) => {
          if (i != j) {
            return m;
          }

          return {
            ...m,
            [key]: value,
          };
        }),
      },
    });
  };

  const disabled = isLineItemEmptyInAdditionalInfo
    ? !!lineItems?.find(
        (l) =>
          !l?.product ||
          !l?.size ||
          !l?.color ||
          !l?.qty ||
          !l?.printType ||
          !!l?.printAreas?.find((q) => !q?.printAreaName || !q?.artworkUrl)
      )
    : !!state?.additionalInfoWithLineItems?.filter(
        (a) =>
          !!a.lineItems?.find(
            (l) =>
              !l?.product ||
              !l?.size ||
              !l?.color ||
              !l?.qty ||
              !l?.printType ||
              !!l?.printAreas?.find((q) => !q?.printAreaName || !q?.artworkUrl)
          )
      )?.length;

  const updateOrder = async () => {
    const lineItems = isLineItemEmptyInAdditionalInfo
      ? state?.orderPdfData?.lineItems
      : state?.additionalInfoWithLineItems?.map((c) => c?.lineItems);

    const payload = {
      lineItems: isLineItemEmptyInAdditionalInfo
        ? lineItems
        : [].concat(...lineItems),
      po: Number(state?.orderPdfData?.orderPO[0]),
      status: 'Pending',
      artProofUrl: state?.artProofUrl,
    };

    return await dispatch(updateStaplesOrder(payload));
  };

  const handleQuickBooksButtonClick = () => {
    const orderType = state?.isStaplesOrder;

    let quickBooksCsvData = [
      [
        '*InvoiceNo',
        '*Customer',
        '*InvoiceDate',
        '*DueDate',
        'Terms',
        'Location',
        'Memo',
        'Item(Product/Service)',
        'ItemDescription',
        'ItemQuantity',
        'ItemRate',
        '*ItemAmount',
        '*ItemTaxCode',
        'ItemTaxAmount',
        'Currency',
      ],
    ];

    quickBooksCsvData.push([
      state?.orderPdfData?.orderPO[0],
      'Staples Promotional Products',
      moment().format('D/M/YYYY'),
      moment().add(1, 'month').format('D/M/YYYY'),
      '',
      '',
      '',
      '',
      `PO-${state?.orderPdfData?.orderPO[0]}`,
      1,
      0.0,
      0.0,
      'HST ON',
      '',
      '',
    ]);

    if (!orderType) {
      quickBooksCsvData.push([
        state?.orderPdfData?.orderPO[0],
        'Staples Promotional Products',
        moment().format('D/M/YYYY'),
        moment().add(1, 'month').format('D/M/YYYY'),
        '',
        '',
        '',
        '',
        `AI Order# ${state?.aiNumber}`,
        1,
        0.0,
        0.0,
        'HST ON',
        '',
        '',
      ]);
    }

    if (!isLineItemEmptyInAdditionalInfo) {
      for (let i = 0; i < state?.additionalInfoWithLineItems.length; i++) {
        const lineItems = state?.additionalInfoWithLineItems[i]?.lineItems;

        const additionalInfo =
          state?.additionalInfoWithLineItems[i]?.additionalInfo;

        let lineItemQuantity = 0;

        for (let index = 0; index < lineItems.length; index++) {
          const { product, size, qty, color } = lineItems[index];
          lineItemQuantity += Number(qty);
          quickBooksCsvData.push([
            state?.orderPdfData?.orderPO[0],
            'Staples Promotional Products',
            moment().format('D/M/YYYY'),
            moment().add(1, 'month').format('D/M/YYYY'),
            '',
            '',
            '',
            '',
            `${product} ${size} ${color}`,
            `${qty}`,
            '',
            0.0,
            'HST ON',
            '',
            '',
          ]);
        }

        quickBooksCsvData.push([
          state?.orderPdfData?.orderPO[0],
          'Staples Promotional Products',
          moment().format('D/M/YYYY'),
          moment().add(1, 'month').format('D/M/YYYY'),
          '',
          '',
          '',

          additionalInfo
            ?.find((g) => g?.startsWith('Decoration Method'))
            .split('Decoration Method: ')[1],
          additionalInfo.join(' '),
          lineItemQuantity,
          0.0,
          0.0,
          'HST ON',
          '',
          '',
        ]);
      }
    } else {
      const lineItems = state?.orderPdfData?.lineItems;
      let lineItemQuantity = 0;
      for (let index = 0; index < lineItems.length; index++) {
        const { product, size, qty, color } = lineItems[index];
        lineItemQuantity += Number(qty);
        quickBooksCsvData.push([
          state?.orderPdfData?.orderPO[0],
          'Staples Promotional Products',
          moment().format('D/M/YYYY'),
          moment().add(1, 'month').format('D/M/YYYY'),
          '',
          '',
          '',
          `${qty} ${product} ${size} ${color}`,
          `${qty} ${product} ${size} ${color}`,
          '',
          0.0,
          0.0,
          'HST ON',
          '',
          '',
        ]);
      }
      for (
        let index = 0;
        index < state?.orderPdfData?.grandAdditionalInfo?.length;
        index++
      ) {
        const element = state?.orderPdfData?.grandAdditionalInfo[index];

        quickBooksCsvData.push([
          state?.orderPdfData?.orderPO[0],
          'Staples Promotional Products',
          moment().format('D/M/YYYY'),
          moment().add(1, 'month').format('D/M/YYYY'),
          '',
          '',
          '',

          element
            ?.find((g) => g?.startsWith('Decoration Method'))
            .split('Decoration Method: ')[1],
          element.join(' '),
          lineItemQuantity,
          0.01,
          0.01 * lineItemQuantity,
          'HST ON',
          '',
          '',
        ]);
      }
    }

    if (state?.orderPdfData?.polyBagFees?.length > 0) {
      let data = {
        qty: 0,
        item: '',
        description: '',
      };

      for (
        let index = 0;
        index < state?.orderPdfData?.polyBagFees?.length;
        index++
      ) {
        const element = state?.orderPdfData?.polyBagFees[index];
        data.qty += Number(element.value?.split(' ')[0]?.replace(/\D/g, ''));
        data.item = element.value?.split(' ')[0]?.replace(/[0-9]/g, '');
        data.description = element.value;
      }

      quickBooksCsvData.push([
        state?.orderPdfData?.orderPO[0],
        'Staples Promotional Products',
        moment().format('D/M/YYYY'),
        moment().add(1, 'month').format('D/M/YYYY'),
        '',
        '',
        '',
        data.item,
        data.description,
        data.qty,
        0.5,
        0.5 * data.qty,
        'HST ON',
        '',
        '',
      ]);
    }

    if (state?.orderPdfData?.digitizeFees?.length > 0) {
      let data = {
        qty: 0,
        item: '',
        description: '',
      };
      for (
        let index = 0;
        index < state?.orderPdfData?.digitizeFees?.length;
        index++
      ) {
        const element = state?.orderPdfData?.digitizeFees[index];
        data.qty += Number(element.value?.split(' ')[0]?.replace(/\D/g, ''));
        data.item = element.value?.split(' ')[0]?.replace(/[0-9]/g, '');
        data.description = element.value;
      }

      quickBooksCsvData.push([
        state?.orderPdfData?.orderPO[0],
        'Staples Promotional Products',
        moment().format('D/M/YYYY'),
        '',
        '',
        '',
        '',
        data.item,
        data.description,
        data.qty,
        0.1,
        0.1 * data.qty,
        'HST ON',
        '',
        '',
      ]);
    }

    if (state?.orderPdfData?.handlingCharge?.length > 0) {
      let data = {
        qty: 0,
        item: '',
        description: '',
      };

      for (
        let index = 0;
        index < state?.orderPdfData?.handlingCharge?.length;
        index++
      ) {
        const element = state?.orderPdfData?.handlingCharge[index];
        data.qty += Number(element.value?.split(' ')[0]?.replace(/\D/g, ''));
        data.item = element.value?.split(' ')[0]?.replace(/[0-9]/g, '');
        data.description = element.value;
      }

      quickBooksCsvData.push([
        state?.orderPdfData?.orderPO[0],
        'Staples Promotional Products',
        moment().format('D/M/YYYY'),
        moment().add(1, 'month').format('D/M/YYYY'),
        '',
        '',
        '',
        data.item,
        data.description,
        data.qty,
        0.3,
        0.3 * data.qty,
        'HST ON',
        '',
        '',
      ]);
    }

    quickBooksCsvData.push([
      state?.orderPdfData?.orderPO[0],
      'Staples Promotional Products',
      moment().format('D/M/YYYY'),
      moment().add(1, 'month').format('D/M/YYYY'),
      '',
      '',
      '',
      'B.O.T.:Handling 2',
      'Handling 2',
      1,
      4,
      4,
      'HST ON',
      '',
      '',
    ]);

    setState({
      ...state,
      quickBooksCsvData,
    });

    setTimeout(() => {
      csvFileRef.current?.link?.click();
    }, 0);
  };

  return (
    <StyledForm>
      {state.status === 'In-Production' && (
        <PrintAreasWrapper>
          <PrintAreasHeader>
            <h3>Stock Received Date</h3>
          </PrintAreasHeader>

          <StaplesShippedDate>
            <TextField
              type="date"
              label="Stock Received Date"
              value={state?.stockReceivedDate}
              defaultValue={null}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(v) =>
                setState({
                  ...state,
                  stockReceivedDate: v,
                })
              }
            />

            <Button
              title="Save"
              disabled={!state?.stockReceivedDate}
              onClick={async () => {
                let lineItems = isLineItemEmptyInAdditionalInfo
                  ? state?.orderPdfData?.lineItems
                  : state?.additionalInfoWithLineItems?.map(
                      (c) => c?.lineItems
                    );

                lineItems = isLineItemEmptyInAdditionalInfo
                  ? lineItems
                  : [].concat(...lineItems);

                await dispatch(
                  updateReceivedQty({
                    po: Number(state?.orderPdfData?.orderPO[0]),
                    lineItems: lineItems?.map((l) => ({
                      ...l,
                      stockReceivedDate: state?.stockReceivedDate,
                    })),
                  })
                );
              }}
            />
          </StaplesShippedDate>
        </PrintAreasWrapper>
      )}

      {state.status === 'In-Production' && (
        <PrintAreasWrapper>
          <PrintAreasHeader>
            <h3>BOT Ship Date</h3>
          </PrintAreasHeader>

          <StaplesShippedDate>
            <TextField
              type="date"
              label="BOT Ship Date"
              value={state?.botShipDate}
              defaultValue={null}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(v) =>
                setState({
                  ...state,
                  botShipDate: v,
                })
              }
            />

            <Button
              title="Save"
              disabled={!state?.botShipDate}
              onClick={async () => {
                let lineItems = isLineItemEmptyInAdditionalInfo
                  ? state?.orderPdfData?.lineItems
                  : state?.additionalInfoWithLineItems?.map(
                      (c) => c?.lineItems
                    );

                lineItems = isLineItemEmptyInAdditionalInfo
                  ? lineItems
                  : [].concat(...lineItems);

                await dispatch(
                  updateReceivedQty({
                    po: Number(state?.orderPdfData?.orderPO[0]),
                    lineItems: lineItems?.map((l) => ({
                      ...l,
                      botShipDate: state?.botShipDate,
                    })),
                  })
                );
              }}
            />
          </StaplesShippedDate>
        </PrintAreasWrapper>
      )}
      <FormHeader>
        <FromHeaderTitle>Line Items</FromHeaderTitle>
        {state?.status === 'Pending' && (
          <ButtonWrapper>
            <Button
              title="Save"
              disabled={!state?.artProofUrl}
              containerStyle={{ marginRight: 15 }}
              onClick={async () => {
                const response = await updateOrder();
                setState({
                  ...state,
                  poSubmittedModalVisibility: true,
                  poSubmittedModalMessage: response?.message,
                  poSubmitted: true,
                });
              }}
            />

            <Button
              title="Upload Art Proof PDF"
              containerStyle={{ marginRight: 15 }}
              onClick={async () => {
                openCloudinaryWidget(
                  `BOTApp/StaplesPO/ArtProofDoc`,
                  ['pdf'],
                  (r) =>
                    setState({
                      ...state,
                      artProofUrl: r?.secureUrl,
                    })
                );
              }}
            />

            <Button
              containerStyle={{ marginRight: 15 }}
              title="Submit to Production"
              disabled={disabled || !state?.artProofUrl}
              onClick={async () => {
                const response = await updateOrder();
                setState({
                  ...state,
                  saveToProductionModal: true,
                  poSubmittedModalMessage: response?.message,
                  poSubmitted: true,
                });
              }}
            />

            <Button
              title="Quick Book Files"
              disabled={!state?.artProofUrl}
              onClick={async () => handleQuickBooksButtonClick()}
            />
          </ButtonWrapper>
        )}

        {state?.status === 'In-Production' && (
          <Button
            title="Quick Book Files"
            disabled={!state?.artProofUrl}
            onClick={async () => handleQuickBooksButtonClick()}
          />
        )}
      </FormHeader>
      {!isLineItemEmptyInAdditionalInfo && (
        <Order>
          {additionalInfoWithLineItems?.map((a, i) => (
            <SimpleCard key={`additionalInfoWithLineItems${i}`}>
              <div
                style={{
                  marginBottom: 10,
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <DeleteIcon
                  style={{ color: 'red', cursor: 'pointer' }}
                  onClick={() => {
                    setState({
                      ...state,
                      additionalInfoWithLineItems: _.filter(
                        additionalInfoWithLineItems,
                        (n, j) => {
                          return j !== i;
                        }
                      ),
                    });
                  }}
                />
              </div>

              <FormWrapper>
                <div>
                  {a?.lineItems?.map((d, j) => (
                    <FormFields
                      state={state}
                      lineItems={a?.lineItems}
                      key={`Card${i + j}`}
                      data={d}
                      deleteLineItem={() => {
                        const additionalInfoWithLineItemsTemp =
                          additionalInfoWithLineItems?.map((b, z) =>
                            z !== i
                              ? b
                              : {
                                  ...b,
                                  lineItems: b?.lineItems?.filter(
                                    (x, q) => q !== j
                                  ),
                                }
                          );

                        setState({
                          ...state,
                          additionalInfoWithLineItems:
                            additionalInfoWithLineItemsTemp,
                        });
                      }}
                      handleFieldChange={(key, value) =>
                        handleAdditionalInfoFieldChange(key, value, i, j)
                      }
                    />
                  ))}
                </div>
                <OrderAdditionalInfo data={a?.additionalInfo} />
              </FormWrapper>
            </SimpleCard>
          ))}
        </Order>
      )}

      {isLineItemEmptyInAdditionalInfo && (
        <Order>
          <SimpleCard>
            <FormWrapper>
              <div>
                {lineItems?.map((d, i) => (
                  <FormFields
                    state={state}
                    lineItems={lineItems}
                    key={`Card${i}`}
                    data={d}
                    handleFieldChange={(key, value) =>
                      handleFieldChange(key, value, i)
                    }
                  />
                ))}
              </div>
              {state?.orderPdfData?.grandAdditionalInfo?.map((g, k) => (
                <OrderAdditionalInfo data={g} key={`OrderAdditionalInfo${k}`} />
              ))}
            </FormWrapper>
          </SimpleCard>
        </Order>
      )}

      {!!state?.orderPdfData?.orderPO && (
        <CSVLink
          style={{ display: 'none' }}
          ref={csvFileRef}
          filename={`PO-${state?.orderPdfData?.orderPO[0]}-QuickBooks.csv`}
          data={state?.quickBooksCsvData || []}
        ></CSVLink>
      )}
    </StyledForm>
  );
};

export default Form;
